@if(dataList){
  <app-cards-basic title="{{ 'ALLOCATIONS.title' | translate: {count: 0} }}">

    <mat-nav-list>
      @for (data of dataList; track data) {
        <a mat-list-item
           [routerLink]="[data.id]"
           class="list-border-bottom">
          <span matListItemTitle>{{ data.translations.en.title }}</span>
          <button mat-icon-button (click)="confirmDelete(data.id, $event)" aria-label="Delete" class="trailing-end-button">
            <mat-icon>
              <span class="material-symbols-outlined">delete</span>
            </mat-icon>
          </button>
        </a>
      }
    </mat-nav-list>

    <button mat-flat-button
            color="primary"
            type="button"
            [routerLink]="['new-allocation' | localize]"
            class="bp-button">
      {{ 'ALLOCATIONS.create' | translate }}
    </button>


  </app-cards-basic>
}

